<template>
  <div id="aboutDesktop">
    <div class="card">
      <div class="image">
        <img v-if="!$store.state.cogir" src="@/assets/img/logo.png">
        <img v-if="$store.state.cogir" src="@/assets/img/logo-cogir.png">
      </div>

      <div class="details-right">
        <div>
          <div class="title" v-if="!$store.state.cogir">{{ $t("about.title_2") }}</div>
          <div class="title" v-if="$store.state.cogir">{{ $t("about.cogir.title_2") }}</div>
          <div class="subtitle" v-if="!$store.state.cogir">{{ $t("about.subtitle") }}</div>
          <div class="description" v-if="!$store.state.cogir">
            <p :key="lineIndex" v-for="(line, lineIndex) of $t('about.description_humaniti')">
              {{ line }}
            </p>
          </div>
          <div class="description" v-if="$store.state.cogir">
            <p :key="lineIndex" v-for="(line, lineIndex) of $t('about.cogir.description')">
              {{ line }}
            </p>
          </div>
          <div class="join" >
            <svgicon class="icon" src="svg/mail.svg" :width=25 :height=25></svgicon>
            <div class="address" v-if="!$store.state.cogir">
              <div class="subtitle">{{ $t("about.contact_us") }}</div>
              1020 rue de Bleury<br>
              Montréal (Québec) H3A 2H7<br>
              1-514-444-2959<br>
              administration@humanitimontreal.com
            </div>
            <div class="address" v-if="$store.state.cogir">
              <div class="subtitle">{{ $t("about.contact_us") }}</div>
              7250, Taschereau boulevard, Suite 200<br>
              Brossard (Québec) J4W 1M9
            </div>
          </div>
        </div>
        <div class="buttons">
          <a v-if="!$store.state.cogir" class="btn btn-primary" href="tel:+1-514-444-2959">
            <div class="icon">
              <img src="@/assets/img/icons/phone.png">
            </div>
            <div class="name">{{ $t("about.call") }}</div>
          </a>
          <a v-if="$store.state.cogir" class="btn btn-primary" href="tel:+1-866-671-6381">
            <div class="icon">
              <img src="@/assets/img/icons/phone.png">
            </div>
            <div class="name">{{ $t("about.call") }}</div>
          </a>
          <a v-if="!$store.state.cogir" class="btn btn-primary" href="mailto:administration@humanitimontreal.com">
            <div class="icon">
              <img src="@/assets/img/icons/mail.png">
            </div>
            <div class="name">{{ $t("about.contact") }}</div>
          </a>
         <a v-if="$store.state.cogir" class="btn btn-primary" href="mailto:info@cogir.net">
           <div class="icon">
             <img src="@/assets/img/icons/mail.png">
           </div>
           <div class="name">{{ $t("about.contact") }}</div>
         </a>
          <a v-if="!$store.state.cogir" class="btn btn-primary" href="https://www.humanitimontreal.com/" target="_blank">
            <div class="icon">
              <img src="@/assets/img/icons/website.png">
            </div>
            <div class="name">{{ $t("about.website") }}</div>
          </a>
          <a v-if="$store.state.cogir" class="btn btn-primary" :href="url" target="_blank">
            <div class="icon">
              <img src="@/assets/img/icons/website.png">
            </div>
            <div class="name">{{ $t("about.website") }}</div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "AboutDesktop",

    data() {
      return {
        url: this.$store.state.cogir ? 'http://www.cogir.net/' : 'https://www.humanitimontreal.com/'
      }
    }
  }
</script>

<style lang="scss" scoped>

  #aboutDesktop {
    padding: 30px 60px 30px 60px;
  }

  .image {
    display:flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
    //flex-basis:0;
    background-image: url(../../assets/img/header-about.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    overflow: hidden;
  }

  .details-right {
    flex-grow: 1.3;
    flex-basis: 0;
    padding: 33px 40px 27px;
    &>div {
      flex-grow: 1;
    }
  }

  .card {
    padding: 0;
    border-radius: 2px;
    background-color: #ffffff;
    display: flex;
    min-height: 480px;
    overflow: hidden;
    .title {
      font-size: 24px;
      padding: 0;
      border: none;
      margin-bottom: 5px;
    }
    .image {
      box-sizing: border-box;
      //padding: 40px;
    }
    .image img {
      margin: 40px;
      max-width: 100%;
      object-fit: contain;
    }
  }

  .description {
    padding-bottom: 10px;
    border-bottom: solid #f2f3f4 1px;
    color: #405159;
    font-size: 18px;
  }

  .subtitle {
    color: #808b91;
    font-size: 16px;
  }

  .join {
    display: flex;
    margin: 20px 0 40px 0;
    .address {
      margin: 0 20px;
      font-size: 18px;
    }

    .icon {
      margin-top: 8px;
      fill: #808b91;
    }
  }

  .buttons {
    display: flex;
    flex-basis: 0;
    .btn {
      margin-right: 20px;
      min-width: 150px;

      .icon {
        margin-right: 20px;
      }

    }
  }

  @media screen and (max-width: 1100px) {
    #about .card {
      flex-direction: column;

      .image {
        min-height: 240px;
      }
    }
  }


</style>